import { createSlice } from "@reduxjs/toolkit";
import User from "../../interfaces/user";
import { readSelectedAffiliateIdFromStorage } from "../../utils/common-utils";

const getLocalState = (key: string) => {
  const localState = localStorage.getItem(key);
  if (localState) {
    return JSON.parse(localState);
  }

  return {};
};

const userState = {
  activeUser: getLocalState("activeUser"),
  partners: getLocalState("partners"),
  affiliates: getLocalState("affiliates"),
  affiliateAccount: getLocalState("affiliateAccount"),
  selectedAffiliateId: readSelectedAffiliateIdFromStorage(),
  userRole: getLocalState("userRole"),
  roleLevel: getLocalState("roleLevel"),
  accountId: getLocalState("accountId"),
  initialCalls: getLocalState("initialCalls"),
};

const userSlice = createSlice({
  name: "users",
  initialState: userState,
  reducers: {
    setLoginUser: (state, action) => {
      localStorage.setItem("activeUser", JSON.stringify(action.payload));
      state.activeUser = action.payload;
    },
    setPartners: (state, action) => {
      localStorage.setItem("partners", JSON.stringify(action.payload));
      state.partners = action.payload;
    },
    setAffiliates: (state, action) => {
      localStorage.setItem("affiliates", JSON.stringify(action.payload));
      state.affiliates = action.payload;
    },
    setAffiliateAccount: (state, action) => {
      localStorage.setItem("affiliateAccount", JSON.stringify(action.payload));
      state.affiliateAccount = action.payload;
    },
    setSelectedAffiliateId: (state, action) => {
      if (action.payload == null || action.payload === "") {
        localStorage.removeItem("selectedAffiliateId");
        state.selectedAffiliateId = null;
      } else {
        localStorage.setItem("selectedAffiliateId", JSON.stringify(action.payload));
        state.selectedAffiliateId = action.payload;
      }
    },
    setUserRole: (state, action) => {
      localStorage.setItem("userRole", JSON.stringify(action.payload));
      state.userRole = action.payload;
    },
    setRoleLevel: (state, action) => {
      localStorage.setItem("roleLevel", JSON.stringify(action.payload));
      state.roleLevel = action.payload;
    },
    resetAffiliateAccount: (state) => {
      localStorage.removeItem("affiliateAccount");
      state.affiliateAccount = {};
    },
    setAccountId: (state, action) => {
      localStorage.setItem("accountId", JSON.stringify(action.payload));
      state.accountId = action.payload;
    },
    setInitialCalls: (state, action) => {
      localStorage.setItem("initialCalls", JSON.stringify(action.payload));
      state.initialCalls = action.payload;
    },
    logoutUser: (state) => {
      if (localStorage.getItem("auth_app_id")) {
        const init_data = JSON.parse(localStorage.getItem("init") || "{}");
        init_data.auth_app_id = localStorage.getItem("auth_app_id");
        localStorage.setItem("init", JSON.stringify(init_data));
      }
      localStorage.removeItem("activeUser");
      localStorage.removeItem("cardholder");
      localStorage.removeItem("partners");
      localStorage.removeItem("affiliates");
      localStorage.removeItem("affiliateAccount");
      localStorage.removeItem("affiliateId");
      localStorage.removeItem("selectedAffiliateId");
      state.affiliateAccount = {};
      state.selectedAffiliateId = null;
      state.activeUser = {} as User;
    },
  },
});

export const {
  setLoginUser,
  logoutUser,
  setPartners,
  setAffiliates,
  setAffiliateAccount,
  setSelectedAffiliateId,
  setUserRole,
  setRoleLevel,
  resetAffiliateAccount,
  setAccountId,
  setInitialCalls,
} = userSlice.actions;
export default userSlice.reducer;
